import { Stack } from "@mui/material";
import { motion } from "framer-motion";
import { Outlet, useLocation, useMatches } from "react-router-dom";
import Menu from "../components/Menu/Menu";
import ReportAppLayout from "./ReportAppLayout";

interface IRouteLayoutHandle {
  layout?: "default" | "report";
}

const DefaultAppLayout = () => {
  const { pathname } = useLocation();
  const matches = useMatches();

  const isReportLayout = matches.some(
    (match) =>
      (match.handle as IRouteLayoutHandle | undefined)?.layout === "report"
  );

  if (isReportLayout) {
    return <ReportAppLayout />;
  }

  return (
    <Stack
      direction={{ sm: "column", lg: "row" }}
      sx={(theme) => ({
        height: "calc(100vh)",
        [theme.breakpoints.down("lg")]: {
          overflow: "hidden",
        },
        overflow: "hidden",
      })}
    >
      <Menu />
      <motion.main
        style={{
          width: "calc(100% - 40px)",
          margin: "10px 20px 10px 10px",
          marginLeft: "20px",
          height: "calc(100% - 20px)",
          overflow: "auto",
        }}
        id="main"
        key={pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 0.7,
          ease: [0.6, -0.05, 0.01, 0.99],
        }}
      >
        <Outlet></Outlet>
      </motion.main>
    </Stack>
  );
};

export default DefaultAppLayout;
